import { allBusinessServices } from "src/businessServices/allBusinessServices";
import { ObjectServiceExt } from "src/businessServices/businessServises.types";
import { loadTranslation } from "src/common/api/apiTranslation";
import { loadServFunctions } from "./apiServFunctions";
import { EdServFunc } from "../ObjectForm2/EdBusinessService";

export const getActualServFuncs = async (
  info: ObjectServiceExt,
): Promise<EdServFunc[]> => {
  const { objectId, serviceId, serviceKey } = info;
  const funcs = await loadServFunctions(objectId, serviceId);
  const bs = allBusinessServices.find(({ key }) => key === serviceKey);
  const funcsMap = new Map(funcs.map((f) => [f.functionName, f]));
  return Promise.all(
    bs?.functions
      ?.filter(({ functionName }) => funcsMap.has(functionName))
      .map(async ({ functionName }) => {
        const curFn = funcsMap.get(functionName);
        const displayName = curFn?.displayFunctionName;
        const locMap = displayName
          ? await loadTranslation(displayName)
          : undefined;
        return {
          functionName,
          active: curFn?.active ?? false,
          displayFunctionName: curFn?.displayFunctionName ?? "",
          displayNameLoc: locMap?.translations ?? {},
        };
      }) ?? [],
  );
};
